<script setup lang="ts">
import Pdf from "@/components/Pdf.vue"
import { type Invitation } from "@/model/app/invitation"
import AcceptGenericInvitation from "@/pages/Tasks/Tasks/AccountInvitation/AcceptGenericInvitation.vue"
import AccountInvitationToAdmin from "@/pages/Tasks/Tasks/AccountInvitation/AccountInvitationToAdmin.vue"
import { defineTranslations } from "@/utils/defineTranslations"
import { ref } from "vue"
import { type TasksProps } from "./tasks-props"

const props = defineProps<TasksProps<Invitation>>()
const emit = defineEmits<{
    (e: "updated"): void
}>()

const model = ref({})

const infos = props.task.infos as {
    text: [
        // translation key
        string,
        // translation params
        Record<string, string>,
    ]
}

const trans = defineTranslations({
    "organization_member.myself": {
        de: 'Um die Einladung anzunehmen gehe zu "Meine Registrierungen" und dort auf "Meine Registrierungen als Person über eine Organisation".',
        en: 'To accept this invitation, go to "My Registrations" and then to "My Registrations as a Person via an Organization".',
    },
    "organization_member.manager": {
        de: 'Um die Einladung anzunehmen gehe zu "Meine Registrierungen" und dort auf "Meine Personen-Verwaltung".',
        en: 'To accept this invitation, go to "My Registrations" and then to "My Person Management".',
    },
    "go_to_my_registrations": {
        de: 'Gehe zu "Meine Registrierungen"',
        en: 'Go to "My Registrations"',
    },
})
</script>

<template>
    <div class="p-4">
        <template v-if="infos?.text">
            {{ $t(infos.text[0], infos.text[1], props.task.numberOfAccounts ?? 0) }}
        </template>

        <div v-if="viewMode === 'customer' && props.task.state === 'open'" class="mt-4">
            <div class="mt-3" v-if="props.task.accountType == 'Organization'">
                <pdf file="/legal/show/General.Organization/pdf"></pdf>
            </div>
            <div v-if="props.task.accountType == 'Admin'" class="mb-3">
                <AccountInvitationToAdmin
                    @update:model-value="model = $event"
                    @updated="emit('updated')"
                    v-bind="props"
                ></AccountInvitationToAdmin>
            </div>

            <div v-else-if="props.task.accountType === 'OrganizationMember' && props.task.managementType === 'myself'">
                <div class="mb-3">
                    {{ trans("organization_member.myself") }}
                </div>

                <RouterLink
                    class="btn btn-primary"
                    :to="{ name: '@App.MyAthletes.index', query: { _tab: 'my_own_memberships' } }"
                >
                    {{ trans("go_to_my_registrations") }}
                </RouterLink>
            </div>

            <div v-else-if="props.task.accountType === 'OrganizationMember' && props.task.managementType === 'manager'">
                <div class="mb-3">
                    {{ trans("organization_member.manager") }}
                </div>

                <RouterLink
                    class="btn btn-primary"
                    :to="{ name: '@App.MyAthletes.index', query: { _tab: 'my_managed_memberships' } }"
                >
                    {{ trans("go_to_my_registrations") }}
                </RouterLink>
            </div>

            <div v-else>
                <AcceptGenericInvitation @updated="emit('updated')" v-bind="props"></AcceptGenericInvitation>
            </div>
        </div>
    </div>
</template>
